export default "__VITE_ASSET__BIbCgV7___"